import { AppConfig } from '../helper/app.config';

/**
 * Beschreibt welche Wiege-Quellen für den aktuell konfigurierten Waage-Modus erlaubt sind.
 */
export interface WaageModusInfo {
    /**
     * Die App darf eine Wiegung selbst auslösen (Erst-/Zweitwiegung).
     */
    wiegenDurchApp: boolean;

    /**
     * Wiegungen, die nicht von der App angefordert wurden (z.B. über die Handtaster am Fahrzeug),
     * werden gesammelt und können anschließend einer Auftragsposition zugeordnet werden.
     */
    zuordnen: boolean;
}

/**
 * Gibt zurück welche Wiege-Quellen erlaubt sind.
 *
 * 'zuordnen' und 'wiegen' verhalten sich unverändert.
 * 'beides' erlaubt beide Quellen gleichzeitig (für OFK: Wiegung aus der App UND über die Handtaster am Fahrzeug).
 */
export function getWaageModusInfo(): WaageModusInfo {
    switch (AppConfig.current?.einstellungen?.WaageModus) {
        case 'wiegen':
            return { wiegenDurchApp: true, zuordnen: false };

        case 'beides':
            return { wiegenDurchApp: true, zuordnen: true };

        default:
            // 'zuordnen' (Standard)
            return { wiegenDurchApp: false, zuordnen: true };
    }
}
